import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import ImageWithFallback from '../components/ImageWithFallback';
import { martyrsApi } from '../services/api';
import { excerpt } from '../utils/place';

const BiographyPage = () => {
  const [params] = useSearchParams();
  const [martyrs, setMartyrs] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    martyrsApi.getAll({ limit: 50 }).then((data) => {
      const list = data.martyrs || [];
      setMartyrs(list);
      const fromQuery = list.find((item) => String(item.id) === params.get('id'));
      setSelected(fromQuery || list[0] || null);
    });
  }, [params]);

  return (
    <Layout>
      <Seo title="السيرة الذاتية" />
      <PageHero eyebrow="التوثيق" title="السيرة الذاتية" subtitle="وجوه وسير. اختر شهيداً لتقرأ نبذته الكاملة." />
      <div className="container-responsive grid gap-10 py-12 lg:grid-cols-3">
        <aside className="space-y-2">
          {martyrs.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => setSelected(item)}
              className={`w-full rounded-2xl px-4 py-3 text-right ${selected?.id === item.id ? 'bg-primary-900 text-white' : 'bg-white dark:bg-stone-900'}`}
            >
              {item.name_ar}
            </button>
          ))}
        </aside>
        {selected && (
          <article className="lg:col-span-2 overflow-hidden rounded-[2rem] bg-white shadow-large dark:bg-stone-900">
            <div className="h-80">
              <ImageWithFallback
                key={selected.id}
                src={selected.image_url || '/default.png'}
                alt={selected.name_ar}
                className="h-full w-full object-cover"
              />
            </div>
            <div className="space-y-4 p-8">
              <h2 className="text-3xl font-bold">{selected.name_ar}</h2>
              <p className="text-stone-500">{selected.occupation}</p>
              <p className="whitespace-pre-line text-lg leading-loose">{selected.bio || excerpt(selected.occupation, 80)}</p>
              <Link to={`/martyr/${selected.id}`} className="btn btn-primary">الصفحة الكاملة</Link>
            </div>
          </article>
        )}
      </div>
    </Layout>
  );
};

export default BiographyPage;
